import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class Progress extends React.Component
{
    static propTypes = {
        percentage: PropTypes.number,
        error: PropTypes.bool
    };

    static defaultProps = {
        percentage: 0,
        error: false
    };

    render()
    {
        const percentage = this.props.error || this.props.percentage > 100 ? 100 : this.props.percentage;

        const widthStyle = {width: percentage + '%'};

        const classes = classNames({
            'h-2 rounded': true,
            'bg-blue-900': ! this.props.error,
            'bg-red-900': this.props.error
        });

        return <div className="h-2 rounded bg-gray-400 w-full">
            <div className={classes} style={{...widthStyle}} />
        </div>;
    }
}
